import { Component, Input } from '@angular/core';

@Component({
    selector: 'loading-container',
    templateUrl: './loading-container.component.html',
    styleUrls: ['./loading-container.component.scss'],
})
export class LoadingContainerComponent {

    @Input()
    public loading: boolean;

    @Input()
    public dadosCarregados: boolean;

    @Input()
    public mensagem: string;

    constructor() {

    }

}
